import { render, staticRenderFns } from "./ElementStudioPostChooserOptions.vue?vue&type=template&id=bc36e576&"
import script from "./ElementStudioPostChooserOptions.vue?vue&type=script&lang=ts&"
export * from "./ElementStudioPostChooserOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports